import * as React from 'react'
import { IStageProps } from 'app/types'
import StageCounter from 'app/comp/stage-counter'
import Clock from 'app/comp/clock'


export default class DoNotPushStage extends React.Component<IStageProps, {
}> {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  handleClick = () => {
    this.props.onNext()
  }

  render() {
    return (
      <div>

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <button onClick={this.handleClick}>Do not push</button>

      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/do-not-push.tsx